// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    apiUrl: "https://gateway-e919a.patient-np.davita.com/api/support-portal/v1",
    authorization: {
      teammate:{
        issuer_uri: "https://ping-auth-proxy.patient.davita.com/auth-app/Proxy",
        client_id: "IPS_DEV_Client",
        client_secret: "cKQa879pv4F36bkSR6TDChYEBKw0mUU9HsyfWvIBk4fQZiQ2z9uaQCoV0jZOoeQU",
        redirect_uri: window.location.origin + "/login",
        scope: "openid",
        login_type: "teammate"
      }
    }
  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
  